import { render } from "./ExclamationTriangle.vue?vue&type=template&id=15782888"
import script from "./ExclamationTriangle.vue?vue&type=script&lang=js"
export * from "./ExclamationTriangle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__